import Logo from "@/components/header/logo";
import Detalhes from "@/features/Detalhes";
import StepAcordions from "@/components/acorddions/stepAcordions";
import Usuario from "@/features/Usuario";
import Sucesso from "@/features/Sucesso";
import Rodape from "@/features/Rodape";
import CortesiaBlock from "@/features/Cortesia";
import {useSelector} from "react-redux";
import {GET_USER_STEP, GET_USER_TAB} from "@/store/slices/appSlice";
import PrecisaAjuda from "@/features/PrecisaAjuda";
import Chat from "@/features/Chat";
import Mensagem from "@/features/Mensagem";
import Modals from "@/components/modals";
import { GET_USER } from "@/store/slices/userSlice";


export default function Cortesia() {
    const finishStep = 3;
    const current = useSelector(GET_USER_STEP)
    const USER_TAB = useSelector(GET_USER_TAB)
    const USER = useSelector(GET_USER)

    return (
        <>
            <Logo/>
            <Detalhes/>
            <StepAcordions title={'Identificação'} page="cortesia" subtitle={USER.email} step={'1'}>
                <Usuario></Usuario>
            </StepAcordions>
            <StepAcordions title={'Assinar'} step={'2'} page="cortesia">
                <CortesiaBlock />
            </StepAcordions>
            {current === finishStep && <Sucesso />}
            <PrecisaAjuda />
            {USER_TAB === 3 && 
            <>
                <Chat />
                <Mensagem />
            </>            

            }
            <Rodape />
            <Modals />
        </>
    )
}
